/** Web Push subscription endpoints (/api/push/*) — see api push module. */
import type { ApiResponse } from '@system/shared'
import { apiFetch } from './api-client-core'

export function getPushVapidPublicKey(): Promise<ApiResponse<{ publicKey: string }>> {
  return apiFetch('/api/push/vapid-public-key')
}

export function subscribePush(sub: PushSubscriptionJSON): Promise<ApiResponse<{ ok: boolean }>> {
  return apiFetch('/api/push/subscribe', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(sub),
  })
}

export function unsubscribePush(endpoint: string): Promise<ApiResponse<{ ok: boolean }>> {
  return apiFetch('/api/push/subscribe', {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ endpoint }),
  })
}

export function sendPushTest(): Promise<ApiResponse<{ sent: number }>> {
  return apiFetch('/api/push/test', { method: 'POST' })
}
